import { FC } from 'react';

import WaveUIForm_V2 from '@/shared/components/forms/WaveUIForm_V2';
import FieldType from '@/shared/components/forms/WaveUIForm_V2/types/fieldType.enum';

import useSetOriginForm from './hooks/useSetOriginForm';

type SetOriginFormProps = {
  setOriginFormState: ReturnType<typeof useSetOriginForm>;
};

const SetOriginForm: FC<SetOriginFormProps> = ({ setOriginFormState }) => {
  const { pickOriginForm, fulfilmentProviderOrigins, setPickOriginForm } =
    setOriginFormState;

  return (
    <WaveUIForm_V2
      fields={[
        {
          field_type: FieldType.Select,
          field_props: {
            name: 'fulfilmentOrigin',
            label: 'Fulfilment Origin',
            value: pickOriginForm.fulfilmentOrigin,
            placeholder: 'Fulfilment Origin',
            options:
              fulfilmentProviderOrigins?.map((item) => ({
                label: item.name,
                value: item.fulfilment_origin_id,
              })) || [],
          },
        }, 
        {
          field_type: FieldType.Select,
          field_props: {
            name: 'package_type',
            label: 'Package Type',
            value: pickOriginForm.package_type,
            placeholder: '',
            options: [
              {
                label: 'Courier Pack',
                value: 'courier-pak',
              },
              {
                label: 'Package',
                value: 'package',
              },
              {
                label: 'Envelope',
                value: 'envelope',
              },
            ],
          },
        },
        {
          isVisible: pickOriginForm.useCustomsBroker,
          field_type: FieldType.Select,
          field_props: {
            name: 'source',
            label: 'Customs Source',
            value: pickOriginForm.source,
            placeholder: '',
            options: [
              {
                label: 'Details',
                value: 'details',
              },
              {
                label: 'In Person',
                value: 'in-person',
                disabled: true,
              },
            ],
          },
        },
        {
          field_type: FieldType.Switch,
          field_props: {
            name: 'useCustomsBroker',
            label: 'Use Customs Broker',
            checked: pickOriginForm.useCustomsBroker,
          },
        },
        {
          isVisible: pickOriginForm.useCustomsBroker,
          field_type: FieldType.Switch,
          field_props: {
            name: 'use_carrier',
            label: 'Use Carrier',
            checked: pickOriginForm.use_carrier,
          },
        },
        {
          isVisible: !pickOriginForm.use_carrier,
          field_type: FieldType.Text,
          field_props: {
            required: true,
            name: 'name',
            label: 'Name',
            value: pickOriginForm.name,
            placeholder: 'Name ...',
          },
        },
        {
          isVisible: !pickOriginForm.use_carrier,
          field_type: FieldType.Text,
          field_props: {
            required: true,
            name: 'account_number',
            label: 'Account Number',
            value: pickOriginForm.account_number,
            placeholder: 'Account Number ...',
          },
        },
        {
          isVisible: !pickOriginForm.use_carrier,
          field_type: FieldType.Text,
          field_props: {
            required: true,
            name: 'phone_number',
            label: 'Phone Number',
            value: pickOriginForm.phone_number,
            placeholder: 'Phone Number ...',
          },
        },
        {
          isVisible: !pickOriginForm.use_carrier,
          field_type: FieldType.Text,
          field_props: {
            required: true,
            name: 'email_address',
            label: 'Email Address',
            value: pickOriginForm.email_address,
            placeholder: 'Email Address ...',
          },
        },
        {
          isVisible: !pickOriginForm.use_carrier,
          field_type: FieldType.Text,
          field_props: {
            name: 'fax_number',
            label: 'Fax Number',
            value: pickOriginForm.fax_number,
            placeholder: 'Fax Number ...',
          },
        },
        {
          isVisible: !pickOriginForm.use_carrier,
          field_type: FieldType.Text,
          field_props: {
            name: 'usmc_number',
            label: 'USMC Number',
            value: pickOriginForm.usmc_number,
            placeholder: 'USMC Number ...',
          },
        },
        {
          isVisible: !pickOriginForm.use_carrier,
          field_type: FieldType.Text,
          field_props: {
            name: 'fda_number',
            label: 'FDA Number',
            value: pickOriginForm.fda_number,
            placeholder: 'FDA Number ...',
          },
        },
      ]}
      getFieldsValues={(value) => {
        setPickOriginForm((prev) => ({ ...prev, ...value }));
      }}
    />
  );
};

export default SetOriginForm;
